module.exports = 'ontouchstart' in global || (global.DocumentTouch && document instanceof DocumentTouch)


//////////////////
// WEBPACK FOOTER
// ../~/has-touch/index.js
// module id = 2377
// module chunks = 2